export const SAVE_STATUS = {
  START: 'startSaving',
  END: 'endSaving'
};

export const SAVING_DURATION = 1000; // 1s, duration the the static phase of saving animation takes to end
